import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import { required, requiredIf, maxLength, minLength, email, numeric } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import CONFIG from "@/assets/js/config.js";

const convertNumberService = new ConvertNumService();

export default {
  name: "EmployeeEdit",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },

  data() {
    const store = this.$store;
    return {
      adminNo: store?.state?.user?.admin_no,
      userRole: store?.state?.user?.role,
      currentUserEmployeeId: store?.state?.user?.employee?.id,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      config: CONFIG,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      submitted: false,
      disabled: false,
      pwd_change: false,
      roleNameErr: false,
      adminRole: [],
      admin: {
        role: '',
        role_name: '',
      },
      employeeData: {
        employeeable_flag: 1,
        employeeable_type_text: '',
        teacher_type_id: '',
        name: '',
        password: '',
        confirm_password: '',
        dob: '',
        nationality: '',
        religion: '',
        marital_status: '',
        gender: '',
        father_name: '',
        email: '',
        phone1: '',
        phone2: '',
        contact_address: '',
        permanent_address: '',
        edu_background: '',
        other_certificate: '',
        work_experience: '',
        join_date: '',
        resign_date: '',
        parent_chat_enable: CONFIG.TEACHER_PARENT_CHAT ? CONFIG.TEACHER_PARENT_CHAT.DISABLE : 0,
        employment_type: CONFIG.EMPLOYMENT_TYPE.FULL_TIME,
        nrc_number: '',
        status: 0,
        ferry_status: 0,
      },
      selectedReligion: 0,
      religionArr: null,
      teacherTypeArr: null,
      employeeImage: "",
      nrcFrontImage: "",
      nrcBackImage: "",
      teacherOldImage: "",
      nrcFrontOldImage: "",
      nrcBackOldImage: "",
      signImage: "",
      signOldImage: "",
      teacher_type: "",
      religion: "",
      nrcNameJson: null,
      naingJson: null,
      nrcno: null,
      nrc_number: "",
      nrc_only_number: "",
      nrc: "",
      nrckey: "",
      selectedNrcName: "",
      selectedNrcNaing: "",
      districtList: [],
      naingList: [],
      nrcName: [],
      previewUrl: false,
      employeeFile: null,
      existingFile: null,
      oldEmployeeFile: null,
      old_url: null,
      emailExists: null,
      parent_chat_enable: CONFIG.TEACHER_PARENT_CHAT.ENABLE,
      parent_chat_disable: CONFIG.TEACHER_PARENT_CHAT.DISABLE,
      employmentTypeOptions: Object.entries(CONFIG.EMPLOYMENT_TYPE_TXT).map(([id, text]) => ({
        id: Number(id),
        text,
      })),
      employeeFlag: CONFIG.EMPLOYEE_FLAG,
    };
  },

  validations: {
    admin: {
      role: {
        required: requiredIf(function () {
          return Number(this.employeeData.employeeable_flag) === this.employeeFlag.STAFF;
        })
      },
      role_name: {
        required: requiredIf(function () {
          const isStaff = Number(this.employeeData.employeeable_flag) === this.employeeFlag.STAFF;
          const isOtherRole = String(this.admin.role) === String(this.config.ROLE.ID.OTHER);

          return isStaff && isOtherRole;
        }),
        maxLength: maxLength(100),
      }
    },
    employeeData: {
      name: {
        required,
        maxLength: maxLength(100),
      },
      dob: {
        required,
        maxLength: maxLength(100),
      },
      gender: {
        required,
      },
      father_name: {
        required,
        maxLength: maxLength(50),
      },
      teacher_type_id: {
        required: requiredIf(function () {
          return Number(this.employeeData.employeeable_flag) === this.employeeFlag.TEACHER;
        })
      },

      parent_chat_enable: {
        required: requiredIf(function () {
          return Number(this.employeeData.employeeable_flag) === this.employeeFlag.TEACHER;
        })
      },
      marital_status: {
        required,
      },
      nrc_number: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6)
      },
      nationality: {
        required,
        maxLength: maxLength(100),
      },
      edu_background: {
        maxLength: maxLength(1000)
      },
      other_certificate: {
        maxLength: maxLength(1000)
      },
      work_experience: {
        maxLength: maxLength(1000)
      },
      join_date: {
        required,
      },
      email: {
        maxLength: maxLength(50),
        email
      },
      ferry_status: {
        required: requiredIf(function () {
          return Number(this.employeeData.employeeable_flag) === this.employeeFlag.TEACHER;
        }),
      },
      phone1: {
        required,
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11)
      },
      phone2: {
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11)
      },
      contact_address: {
        required,
        maxLength: maxLength(1000)
      },
      permanent_address: {
        maxLength: maxLength(1000)
      },
      status: {
        required: requiredIf(function () {
          return Number(this.employeeData.employeeable_flag) === this.employeeFlag.STAFF;
        }),
      },
    },
  },

  computed: {
    isTeacher() {
      return Number(this.employeeData.employeeable_flag) === this.employeeFlag.TEACHER;
    }
  },

  methods: {
    getAdminRole() {
      const roles = CONFIG.ROLE.TXT;
      let result = [
        {
          id: 0,
          text: 'Select'
        }
      ];
      Object.entries(roles).forEach(([id, key]) => {
        result.push({
          id: Number(id),
          text: key
        });
      });
      this.adminRole = result;
    },

    getReligion() {
      const result = [{
        id: 0,
        text: 'Select'
      }];
      Object.entries(CONFIG.RELIGION).forEach(([id, key]) => {
        result.push({
          id: id,
          text: key
        });
      });
      this.religionArr = result;
    },

    getNrcData() {
      this.nrcno = CONFIG.NRC.CITY;
      this.naingJson = CONFIG.NRC.NAING;
      this.nrcNameJson = CONFIG.NRC.TOWNSHIP;
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);
    },

    async onChange(event) {
      var optionText = event.target.value;
      var convertNumberService = new ConvertNumService();
      var optionValue = convertNumberService.convertMm2Eng(optionText);
      if (optionValue) {
        this.nrckey = optionText;
      } else {
        this.nrckey = optionValue;
      }
      this.selectedNrcName = "";
      this.districtList = await this.changeNrcName(optionValue);
    },

    changePassword() {
      this.pwd_change = true;
    },

    async changeNrcName(value) {
      return new Promise((resolve, reject) => {
        if (value) {
          this.nrcName = this.nrcNameJson[value];
          resolve(this.nrcName);
        } else {
          reject(new Error('Invalid value for NRC'));
        }
      });
    },

    onChangeNrcName(event) {
      var optionValue = event.target.value;
      if (!optionValue) {
        this.selectedNrcNaing = "";
        this.employeeData.nrc_number = "";
      }
      this.naingList = this.naingJson;
    },

    checkNRC() {
      if (this.nrckey !== undefined && this.selectedNrcName !== undefined && this.selectedNrcNaing !== undefined && this.employeeData.nrc_number !== "") {
        return true;
      } else if (this.nrckey == undefined && this.selectedNrcName == undefined && this.selectedNrcNaing == undefined && this.employeeData.nrc_number == "") {
        return true;
      } else return false;
    },

    mergeNRC() {
      return convertNumberService.convertEng2Mm(this.nrckey + "/" + this.selectedNrcName + this.selectedNrcNaing + this.employeeData.nrc_number);
    },

    async getEmployeeDetail() {
      this.isLoading = true;

      const requestedEmployeeId = this.$route.params.id;
      const isSuperAdmin = this.adminNo === '0001' || Number(this.userRole) === CONFIG.ROLE.ID.SUPER_ADMIN;
      const isHrOperator = Number(this.userRole) === CONFIG.ROLE.ID.HR_OPERATOR;
      const isOwnProfile = String(this.currentUserEmployeeId) === String(requestedEmployeeId);

      if (!isSuperAdmin && !isHrOperator && !isOwnProfile) {
        this.employeeData = {};
        this.isLoading = false;
        return;
      }

      try {
        const response = await axios.get("/employee/" + requestedEmployeeId, {
          params: {
            campus_id: (this.$store.state.user && this.$store.state.user.campus_id) || null,
          }
        });

        if (response.data) {
          this.employeeData = response.data;

          const flag = Number(response.data.employeeable_flag);
          const staffFlag = Number(this.employeeFlag?.STAFF ?? 2);

          if (flag === staffFlag) {
            const rawRole = response.data.role ?? response.data.employeeable?.role ?? null;
            const rawRoleName = response.data.role_name ?? response.data.employeeable?.role_name ?? null;

            this.admin.role = rawRole !== null ? String(rawRole) : '';
            this.admin.role_name = rawRoleName !== null ? rawRoleName : '';
          } else {
            this.admin.role = '';
            this.admin.role_name = '';
          }

          if (response.data.employeeInfo && response.data.employeeInfo.file_name) {
            this.oldEmployeeFile = response.data.employeeInfo.file_name;
            this.old_url = response.data.employeeInfo.url;
          } else {
            this.oldEmployeeFile = null;
            this.old_url = null;
          }
          this.employeeImage = this.employeeData.profile || '';
          this.nrcFrontImage = this.employeeData.nrc_front || '';
          this.nrcBackImage = this.employeeData.nrc_back || '';
          this.signImage = this.employeeData.sign_img || '';

          if (this.employeeData.nrc_number && this.employeeData.nrc_number.includes('/')) {
            try {
              var nrcfirst = this.employeeData.nrc_number.split('/');
              var nrcsecond = nrcfirst[1].split('(');
              var nrcthird = nrcsecond[1].split(')');

              var convertNumberService = new ConvertNumService();
              var nrckeyEng = convertNumberService.convertMm2Eng(nrcfirst[0]);

              this.nrckey = nrcfirst[0];
              this.selectedNrcName = nrcsecond[0];
              this.districtList = await this.changeNrcName(nrckeyEng);
              this.naingList = this.naingJson;
              this.selectedNrcNaing = '(' + nrcthird[0] + ')';
              this.employeeData.nrc_number = nrcthird[1];
            } catch (e) {
              console.warn("NRC format parsing error:", e);
            }
          }

          if (this.employeeData.religion != null) {
            this.selectedReligion = this.religion = this.employeeData.religion;
          }

          if (this.employeeData.employeeInfo != null) {
            this.previewUrl = true;
            this.existingFile = this.employeeData.employeeInfo.file_name;
            this.employeeFile = null;
          } else {
            this.previewUrl = false;
          }

          if (this.teacherTypeArr && this.employeeData.teacher_type_id) {
            const teacherTypeExists = Object.values(this.teacherTypeArr).some(
              value => value['id'] == this.employeeData.teacher_type_id
            );
            if (!teacherTypeExists) {
              this.employeeData.teacher_type_id = "";
            }
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.employeeData = {};
          this.isLoading = false;
          return;
        }
        if (error.response && error.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error("Employee Detail API Error:", error);
      } finally {
        this.isLoading = false;
      }
    },

    getTeacherType() {
      axios.get('getTeacherType')
        .then(res => {
          this.teacherTypeArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    chooseFiles(id) {
      document.getElementById(id).click();
    },

    uploadImage(id) {
      const inputfile = document.getElementById(id).files[0];
      if (inputfile) {
        if (inputfile.type.includes("image/")) {
          if (id == 'signImage' && inputfile.type !== "image/png") {
            this.$notification.error("Only PNG file type allowed!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          if (inputfile.type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.readAsDataURL(inputfile);
          reader.onloadend = () => {
            if (reader.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
            } else {
              this.$set(this, id, reader.result);
            }
          };
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    removeImg(img) {
      this.$set(this, img, '');
      document.getElementById(img).value = '';
    },

    openFileInput() {
      this.$refs.fileInput.click();
    },

    triggerFileInput() {
      if (!this.previewUrl && !this.oldEmployeeFile) {
        this.openFileInput();
      }
    },

    handleFileChange(event) {
      this.existingFile = null;
      const selectedFile = event.target.files[0];
      if (!selectedFile) return;

      const allowedTypes = ['.zip'];
      const fileType = selectedFile.name.substring(selectedFile.name.lastIndexOf('.')).toLowerCase();

      if (selectedFile.size > 10485760) {
        this.$notification.error("Zip File too large", {
          timer: 3,
          position: "bottomCenter",
        });
        this.$refs.fileInput.value = '';
      } else if (allowedTypes.includes(fileType)) {
        this.employeeFile = selectedFile;
        this.previewUrl = URL.createObjectURL(selectedFile);
      } else {
        this.$notification.error("File not supported!", {
          timer: 3,
          position: "bottomCenter",
        });
        this.$refs.fileInput.value = '';
      }
    },

    removeFile() {
      this.employeeFile = null;
      this.previewUrl = null;
      this.oldEmployeeFile = null;
      this.existingFile = null;

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

    deleteFile() {
      this.previewUrl = false;
      this.existingFile = null;
      this.employeeFile = null;
    },

    async confirmUpdate() {
      this.submitted = true;
      const isStaff = Number(this.employeeData.employeeable_flag) === this.employeeFlag.STAFF;
      if (isStaff && String(this.admin.role) === String(CONFIG.ROLE.ID.OTHER) && !this.admin.role_name) {
        this.roleNameErr = true;
      } else {
        this.roleNameErr = false;
      }

      if (this.$v.$invalid || this.emailExists) {
        return;
      } else if (this.pwd_change) {
        if (this.employeeData.password == '' || this.employeeData.password == undefined || this.employeeData.confirm_password == '' || this.employeeData.confirm_password == undefined) {
          return;
        } else if (this.employeeData.password.length < 8 || this.employeeData.password.length > 20 || this.employeeData.confirm_password.length < 8 || this.employeeData.confirm_password.length > 20) {
          return;
        } else if (this.employeeData.password != this.employeeData.confirm_password) {
          this.$notification.error("Password and confirm password do not match.", {
            timer: 3,
            position: "bottomCenter",
          });
          return;
        }
      }
      this.update();
    },

    update() {
      this.isLoading = true;
      this.disabled = true;
      const formData = new FormData();
      formData.append('role', this.admin.role == null ? '' : this.admin.role);
      formData.append('role_name', this.admin.role_name == null ? '' : this.admin.role_name);
      formData.append('status', this.employeeData.status == null ? 0 : this.employeeData.status);
      formData.append('name', this.employeeData.name == null ? '' : this.employeeData.name);
      formData.append('teacher_type_id', this.employeeData.teacher_type_id == null ? '' : this.employeeData.teacher_type_id);
      formData.append('profileImage', this.employeeImage == null ? '' : this.employeeImage);
      formData.append('nrcFrontImage', this.nrcFrontImage == null ? '' : this.nrcFrontImage);
      formData.append('nrcBackImage', this.nrcBackImage == null ? '' : this.nrcBackImage);
      formData.append('employee_file', this.employeeFile == null ? '' : this.employeeFile);
      formData.append('signImage', this.signImage == null ? '' : this.signImage);

      formData.append('profileOldImageName', this.employeeData.profile_path == null ? '' : this.employeeData.profile_path);
      formData.append('nrcFrontOldImageName', this.employeeData.nrc_front_path == null ? '' : this.employeeData.nrc_front_path);
      formData.append('nrcBackOldImageName', this.employeeData.nrc_back_path == null ? '' : this.employeeData.nrc_back_path);
      formData.append('oldEmployeeFile', this.employeeData.employeeInfo == null ? '' : this.employeeData.employeeInfo.file_name);
      formData.append('old_url', this.old_url || '');
      formData.append('signOldImageName', this.employeeData.sign_img_path == null ? '' : this.employeeData.sign_img_path);

      formData.append('religion', this.religion == null ? '' : this.religion);
      formData.append('dob', this.employeeData.dob == null ? '' : this.employeeData.dob);
      formData.append('gender', this.employeeData.gender == null ? '' : this.employeeData.gender);
      formData.append('father_name', this.employeeData.father_name == null ? '' : this.employeeData.father_name);
      formData.append('marital_status', this.employeeData.marital_status == null ? '' : this.employeeData.marital_status);
      formData.append('nrc_number', this.mergeNRC());
      formData.append('nationality', this.employeeData.nationality == null ? '' : this.employeeData.nationality);
      formData.append('edu_background', this.employeeData.edu_background == null ? '' : this.employeeData.edu_background);
      formData.append('other_certificate', this.employeeData.other_certificate == null ? '' : this.employeeData.other_certificate);
      formData.append('work_experience', this.employeeData.work_experience == null ? '' : this.employeeData.work_experience);
      formData.append('join_date', this.employeeData.join_date == null ? '' : this.employeeData.join_date);
      formData.append('resign_date', this.employeeData.resign_date == null ? '' : this.employeeData.resign_date);
      formData.append('password', this.employeeData.password == null ? '' : this.employeeData.password);
      formData.append('email', this.employeeData.email == null ? '' : this.employeeData.email);
      formData.append('ferry_status', this.employeeData.ferry_status == null ? '' : this.employeeData.ferry_status);
      formData.append('phone1', this.employeeData.phone1 == null ? '' : this.employeeData.phone1);
      formData.append('phone2', this.employeeData.phone2 == null ? '' : this.employeeData.phone2);
      formData.append('contact_address', this.employeeData.contact_address == null ? '' : this.employeeData.contact_address);
      formData.append('permanent_address', this.employeeData.permanent_address == null ? '' : this.employeeData.permanent_address);
      formData.append('campus_id', (this.$store.state.user && this.$store.state.user.campus_id) || '');
      formData.append('login_id', (this.$store.state.user && this.$store.state.user.id) || '');
      formData.append('employee_id', this.employeeData.employeeInfo == null ? '' : this.employeeData.employeeInfo.id);
      formData.append('old_url', this.old_url || '');
      formData.append('parent_chat_enable', this.employeeData.parent_chat_enable == null ? CONFIG.TEACHER_PARENT_CHAT.DISABLE : this.employeeData.parent_chat_enable);
      formData.append('employment_type', this.employeeData.employment_type == null ? CONFIG.EMPLOYMENT_TYPE.FULL_TIME : this.employeeData.employment_type);

      axios
        .post("/employee/" + this.$route.params.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success == true) {
            this.$notification.success("Employee Updated Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({ name: "employeeList" });
          } else {
            this.disabled = false;
            this.$notification.error(response.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.$notification.error(error.response.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
          }
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.disabled = false;
          this.isLoading = false;
          console.log("Employee Update API Error", error.errors);
        });
    },

    back() {
      this.$router.go(-1);
    },
  },

  async mounted() {
    this.getAdminRole();
    this.getReligion();
    this.getNrcData();
    this.getTeacherType();
    this.getEmployeeDetail();
  },
};
